export default {
  data() {
    return {
      // tableData: [],
      roleType: JSON.parse(localStorage.getItem('userInfo')).roleType,
      savePath: {},
      myChart: null,
      saveMapEl: []
    }
  },
  methods: {
    setChartData(data) {
      var option = {
        title: {
          // text: '车辆和人员流量统计',
          textStyle: {
            fontSize: 16,
            fontWeight: 'bold',
            color: '#FFFFFF',
          }

        },
        tooltip: {
          trigger: 'axis'
        },
        grid: [
          {
            show: false,
            z: 0,
            left: '2%',
            top: 100,
            right: '2%',
            bottom: 26,
            containLabel: false,
            backgroundColor: 'rgba(0,0,0,0)',
            borderWidth: 1,
            borderColor: '#ccc'
          }
        ],
        legend: {
          data: ['车辆', '人员'],
          left: "right",
          top: 28,
          textStyle: {
            color: "#FFF"
          }
        },

        calculable: true,
        xAxis: [
          {
            type: 'category',
            // prettier-ignore  
            // data: ['11日', '12日', '13日', '14日', '15日', '16日', '17日'],
            data: data.xAxisList[0].data,
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            "axisLine": { //y轴
              "show": false
            },

            "axisTick": { //y轴刻度线
              "show": false
            },

            "splitLine": { //网格线
              "show": false
            }
          }
        ],
        series: [
          {
            name: '车辆',
            type: 'bar',
            data: data.seriesList[0].data,
            markPoint: {
              data: [
                { type: 'max', name: 'Max' }
              ]
            },

          },
          {
            name: '人员',
            type: 'bar',
            data: data.seriesList[1].data,
            markPoint: {
              data: [
                { type: 'max', name: 'Max' }
              ]
            },

          }
        ]
      };
      option && this.myChart.setOption(option);
    },
    initChart(resData) {
      
        if (resData.carCounts) {
        const chartData = {
          seriesList: [{ data: resData.carCounts }, { data: resData.personCount }],
          xAxisList: [{ data: resData.statisticDays }]
        }
        this.setChartData(chartData)
      }
      
      /*
      this.$http.GET_charts().then((res) => {
        if (res.data) {
          fn(res.data)
        }
      })
      */
    },
    drawLine(key, carType = 1) {
      const carMarker = new AMap.Marker({
        map: this.map,
        position: this.savePath['path' + key][0],
        icon: `/static/img/car-${carType}.png`,
        offset: new AMap.Pixel(-12, -8),
        autoRotation: true,
        // angle:0,
      });
      this.saveMapEl.push(carMarker)
      //查询轨迹,绘制轨迹
      var driving = new AMap.Driving({
        // map: this.map,
        hideMarkers: true
      });
      const path =this.savePath['path' + key]
      const arr2 = path.slice(1, -1);
      const waypoints = arr2.map((item) => {
        item = new AMap.LngLat(...item)
        return item
      })
      const that = this;
      let drivingPath = []
      // 根据起终点经纬度规划驾车导航路线
      driving.search(new AMap.LngLat(...path[0]), new AMap.LngLat(...path[path.length - 1]), {
        waypoints
      },
        function (status, result) {
          // result 即是对应的驾车导航信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
          if (status === 'complete') {
            // console.log('绘制驾车路线完成')
            // console.log(result);
            result.routes[0].steps.forEach(element => {
              drivingPath = [...drivingPath, ...element.path]
            });
            // 绘制轨迹
            carMarker.on('moving', function (e) {
              // polyline.setPath(e.passedPath);
              // that.map.setCenter(e.target.getPosition(), true)
            });
            carMarker.moveAlong(drivingPath,  { duration: 2000,autoRotation: true });
          } else {
            console.log('获取驾车数据失败：' + result)
          }
        });
    },
    handleDrawData(resData){
    if(this.roleType==1&&resData&&resData.length)
      {
      this.map.remove(this.saveMapEl);
      this.saveMapEl = []
      setTimeout(()=>{
     let saveLatLng={}
        resData.forEach((item, index) => {
            const lng = parseFloat(item.carTrackList[0].longitude).toFixed(6)
            const lat = parseFloat(item.carTrackList[0].latitude).toFixed(6)
            const keyName = lng+''+lat;
            if(!saveLatLng[keyName]){
              saveLatLng[keyName]=1
            }else{
              saveLatLng[keyName]+=3000
              console.log(2222);
            console.log(keyName,'--',saveLatLng[keyName]);
              // item.vehicleType = 5
            }
            this.savePath['path' + index] = []
            item.carTrackList.forEach((item2) => {
              this.savePath['path' + index].push([item2.longitude, item2.latitude]);
            })
            ;((index,vehicleType,times) => {
              setTimeout(() => {
                this.drawLine(index, vehicleType)
              },times);
            })(index, item.vehicleType,saveLatLng[keyName])
          });
         },300)
       }
    },
    getDrawData(data) {
      this.$axios({
        method: "GET",
        url: '/dqi-hymanage/motorvehicle/getMuiltTrack',
      }).then((res) => {
        if (res.data) {
          this.handleDrawData(res.data)
        }
      })
    }
    
  },
  mounted() {
    var chartDom = document.getElementById('my-chart');
    this.myChart = this.$echarts.init(chartDom);
    
  }
}


// WEBPACK FOOTER //
// ./src/views/home/mixin.js